module.exports = __webpack_public_path__ + "img/champlain_college.52484f18.png";